import * as types from './mutation-types'

export const fetchEmailActions = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/email-actions`, { params }).then((response) => {
      if (response.data.success === true) {
        commit(types.BOOTSTRAP_EMAIL_ACTIONS, response.data.data.data)
        commit(types.SET_TOTAL_EMAIL_ACTIONS, response.data.data.total)
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const SingleEmailActionArray = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/email-actions/singleEmailActionArray/${id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const fetchEmailActionPlaceholders = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/email-actions/emailActionPlaceholder/${id}`).then((response) => {
      commit(types.PLACEHOLDERS, response.data.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const addEmailTemplate = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('/api/super/admin/dynamic-templates', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const addEmailTemplateVersion = ({ commit, dispatch, state }, data) => {
  console.log(data)
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/super/admin/dynamic-templates/${data.template_id}/versions`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const fetchEmailTemplate = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/dynamic-templates/${id}`).then((response) => {
      if (response.data.success === true) {
        commit(types.TEMPLATE_VERSIONS, response.data.data.versions)
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const fetchEmailTemplateVersion = ({ commit, dispatch }, {templateId, versionId}) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/dynamic-templates/${templateId}/versions/${versionId}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const activeEmailTemplateVersion = ({ commit, dispatch }, {templateId, versionId}) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/super/admin/dynamic-templates/${templateId}/versions/${versionId}/activate`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const updateEmailTemplate = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.put(`/api/super/admin/dynamic-templates/${data.id}`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const updateEmailTemplateVersion = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.put(`/api/super/admin/dynamic-templates/${data.templateId}/versions/${data.id}`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const deleteEmailTemplate = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.delete(`/api/super/admin/dynamic-templates/${id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const deleteEmailTemplateVersion = ({ commit, dispatch, state }, {versionId, templateId}) => {
  return new Promise((resolve, reject) => {
    window.axios.delete(`/api/super/admin/dynamic-templates/${templateId}/versions/${versionId}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const changeStatusCommunication = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/communications/${id}/statusChange`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const deselectTemplateVersion = ({ commit, dispatch, state }) => {
  if (state.templateVersions.length > 0) {
    commit(types.TEMPLATE_VERSIONS, [])
  }
}

export const selectAllEmailActions = ({ commit, dispatch, state }) => {
  if (state.selectedEmailActions.length === state.emailActions.length) {
    commit(types.SET_SELECTED_EMAILACTIONS, [])
    commit(types.SET_SELECT_ALL_STATE, false)
  } else {
    let allEmailActionIds = state.emailActions.map(cust => cust.id)
    commit(types.SET_SELECTED_EMAILACTIONS, allEmailActionIds)
    commit(types.SET_SELECT_ALL_STATE, true)
  }
}
export const selectEmailAction = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_EMAILACTIONS, data)
  if (state.selectedEmailActions.length === state.emailActions.length) {
    commit(types.SET_SELECT_ALL_STATE, true)
  } else {
    commit(types.SET_SELECT_ALL_STATE, false)
  }
}
export const setSelectAllState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE, data)
}
